import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { useLanguage } from "./i18n";
import "./styles/global.css";
import 'leaflet/dist/leaflet.css';

const root = createRoot(document.getElementById("root"));
/** Re-mounts the app when the language changes, so every screen re-reads its texts. */
function LocalizedApp() {
  const lang = useLanguage();
  return <App key={lang} />;
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LocalizedApp />
    </BrowserRouter>
  </React.StrictMode>
);

